import { getRegexp } from '@okapi/router-regexp';
import { convertStringsToResources } from './utils';
/**
 * Создает конфиг по умолчанию
 * @param data
 */
function createNewConfig(data = {}) {
    return {
        name: '',
        server: `http://localhost:${process.env.PORT || 3000}/`,
        paths: [''],
        cdnUrl: '',
        sd: '',
        ...data,
        stored: new Map(),
        widgets: new Set(),
        resources: {},
    };
}
export const defaultBundle = 'defaultBundle';
export class StoreConfig {
    static fromMainBundle(mainBundle) {
        const { name, paths, stored = [], widgets = [], resources = {}, ...config } = mainBundle;
        const storeConfig = new StoreConfig();
        storeConfig.setConfig({
            bundle: { name, paths },
            config,
        });
        stored.forEach(c => {
            storeConfig.addStored(c[0], c[1]);
        });
        widgets.forEach(w => {
            storeConfig.config.widgets.add(w);
            storeConfig.config.resources[w] = resources[w];
        });
        return storeConfig;
    }
    constructor() {
        this._stored_paths = [];
        this._presets = {};
        this._descriptions = {};
        this.config = createNewConfig();
    }
    /**
     * Заменить текущий конфиг
     * @param {StoreConfigProps} config
     */
    setConfig({ bundle, config = {} }) {
        this.config = {
            ...this.config,
            name: bundle.name,
            paths: bundle.paths || ['/'],
            ...config,
        };
        this.addStored(this.config.server, this.config.paths);
    }
    /**
     * Объединить новый конфиг с текущим
     * @param config
     */
    mergeConfig(config = {}) {
        this.config = {
            ...this.config,
            ...config,
        };
    }
    /**
     * Имя микрофронта
     */
    get name() {
        if (!this.config.name) {
            return defaultBundle;
        }
        return this.config.name;
    }
    /**
     * Список путей, зарегистрированных на данном конфиге
     * @return {string[]}
     */
    get paths() {
        return this.config.paths.concat([...this.config.widgets].map(w => `/remote-widget/${w}`));
    }
    get server() {
        return this.config.server;
    }
    get cdnUrl() {
        return this.config.cdnUrl !== '' ? this.config.cdnUrl : this.config.server || '';
    }
    get sd() {
        return this.config.sd;
    }
    get reactUrl() {
        return this.config.reactUrl;
    }
    getConfig() {
        return this.config;
    }
    /**
     * Возвращает сериализованый конфиг строкой
     */
    toString() {
        return JSON.stringify(this.toJSON());
    }
    /**
     * Возвращает сериализованый конфиг
     */
    toJSON() {
        return {
            ...this.config,
            widgets: [...this.config.widgets],
            stored: [...this.config.stored.entries()],
            cdnUrl: this.cdnUrl,
            paths: this.paths,
        };
    }
    /**
     * Добавить сохраненные пути для сервера (используется в GlobalRouter)
     * @param {string} server
     * @param {string[]} paths
     */
    addStored(server, paths) {
        if (!this.config.stored.has(server)) {
            this.config.stored.set(server, paths);
            paths.forEach(p => {
                this._stored_paths.push({
                    server,
                    ...getRegexp(p, false, true),
                });
            });
        }
    }
    addWidget(name, resources) {
        this.config.widgets.add(name);
        this.config.resources[name] = convertStringsToResources(resources, this.cdnUrl);
    }
    getResources(name) {
        return this.config.resources[name];
    }
    getWidgets() {
        return this.config.widgets;
    }
    /**
     * Проверяет наличие path в списке закешированных паттернов путей
     * @param {string} path
     * @return {string|null}
     */
    getServerByPath(path) {
        for (let i = 0; i < this._stored_paths.length; i += 1) {
            if (this._stored_paths[i].regexp.exec(path)) {
                return this._stored_paths[i].server;
            }
        }
        return null;
    }
    getServersByUrl(path) {
        const result = [];
        for (let i = 0; i < this._stored_paths.length; i += 1) {
            if (this._stored_paths[i].regexp.exec(path)) {
                result.push(this._stored_paths[i].server);
            }
        }
        return result;
    }
    /**
     * Добавить описание виджета
     * @param {string} name
     * @param {string} description
     */
    addDescription(name, description) {
        this._descriptions[name] = description;
    }
    /**
     * Получить описание виджетов
     * @param {string} name
     */
    getDescription(name) {
        return this._descriptions[name] || '';
    }
    /**
     * Добавить пресет
     * @param {string} name
     * @param {RemotePreset<T>} preset
     */
    addPreset(name, preset) {
        this._presets[name] = (this._presets[name] || []).concat([preset]);
    }
    /**
     * Добавить список пресетов
     * @param {string} name
     * @param {RemotePreset<T>[]} presets
     */
    addPresets(name, presets) {
        this._presets[name] = (this._presets[name] || []).concat(presets);
    }
    /**
     * Получение списка пресетов
     * @param  {string}name
     */
    getPresets(name) {
        return this._presets[name];
    }
    /**
     * Сериализация информации о виджете
     * @param {string} name
     */
    getWidgetInfo(name) {
        return {
            name,
            description: this.getDescription(name),
            presets: this.getPresets(name),
            resources: this.getResources(name),
        };
    }
}
